<template>
  <v-dialog v-model="dialog" persistent max-width="650" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        v-on="on"
        v-bind="attrs"
        block
        depressed
        small
        color="secondary"
        class="mb-3"
        >Movimentação da indicação</v-btn
      >
    </template>
    <v-card flat>
      <v-card-title class="green lighten-4 primary--text font-weight-bold"
        >Movimentação da indicação</v-card-title
      >
      <v-card-subtitle class="green lighten-4"
        >Consulta histórico da indicação</v-card-subtitle
      >
      <v-card-text class="pt-5">
        <v-timeline>
          <v-timeline-item v-for="(mov, i) in indicacao.movimentacao" :key="i" small>
            <template v-slot:opposite>
              <p class="subtitle-1">
                <span
                  >{{ formatarData(mov.data_log) }} às {{ mov.hora_log }}
                </span>
              </p>
            </template>
            <v-card class="py-1" elevation="3">
              <v-card-text>
                <h2
                  class="subtitle-1 font-weight-light"
                  :style="estilostatus(mov.cores)"
                >
                  {{ mov.desc_status }}
                </h2>
                <div v-if="mov.observacao != ''" class="mt-1 mb-4">
                  <i>"{{ mov.observacao }}"</i>
                </div>
                <p class="caption">
                  - {{ mov.usuario }} enviou via {{ mov.tipo_sistema }}
                </p>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { dateFormat } from "@/global";
export default {
  props: {
    indicacao: Object,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    formatarData(value) {
      return dateFormat(value);
    },
    estilostatus(value) {
      return `color: rgb(${value[0]},${value[1]},${value[2]})`;
    },
  },
};
</script>

<style>
</style>